<script>
export default {
  inheritAttrs: false,

  props: {
    label: {
      type: String,
      required: true,
    },

    type: {
      type: String,
      required: false,
      default: 'text',
    },

    error: {
      type: Boolean,
      required: false,
      default: false,
    },

    required: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    onChange(event) {
      this.$emit('input', event.target.value)

      if (this.type === 'file') {
        this.handleFileAssignment(event)
      }
    },

    onSubmit(event) {
      this.$emit('submit')
    },

    handleFileAssignment(event) {
      const [file] = event.target.files
      this.$emit('change', file)
    },
  },
}
</script>

<template>
  <label :class="{ 'text-error': error }">
    <div class="mb-2 font-medium">
      {{ label }}
      <span v-if="required" class="opacity-50">*</span>
    </div>
    <input
      :type="type"
      v-bind="$attrs"
      class="bg-white focus:outline-none border border-gray-300 rounded input block w-full appearance-none leading-normal"
      :class="{ 'border-error': error }"
      @change="onChange"
      @keyup.enter="onSubmit"
    />
  </label>
</template>
